/* Fransk katalog for locale-no.js (del 1 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'common.save': 'Enregistrer les modifications',
  'common.saving': 'Enregistrement...',
  'common.cancel': 'Annuler',
  'common.hoursMinutes': '{h} h {m} min',
  'common.delete': 'Supprimer',
  'common.confirmTitle': 'Êtes-vous sûr ?',
  'common.continue': 'Continuer',
  'account.view': 'Vue des comptes',
  'account.relevant': 'Pertinents',
  'account.all': 'Tous',
  'account.favorites': 'Favoris',
  'account.addFavorite': 'Ajouter aux favoris',
  'account.removeFavorite': 'Retirer des favoris',
  'account.searchHint': 'Rechercher un nom, un numéro ou par ex. 5x',
  'common.working': 'Traitement...',
  'common.close': 'Fermer',
  'common.on': 'Activé',
  'common.off': 'Désactivé',
  'common.active': 'Actif',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'month.short.1': 'Janv.',
  'month.short.2': 'Févr.',
  'month.short.3': 'Mars',
  'month.short.4': 'Avr.',
  'month.short.5': 'Mai',
  'month.short.6': 'Juin',
  'month.short.7': 'Juil.',
  'month.short.8': 'Août',
  'month.short.9': 'Sept.',
  'month.short.10': 'Oct.',
  'month.short.11': 'Nov.',
  'month.short.12': 'Déc.',
  'ui.summary.title': 'Récapitulatif',
  'ui.summary.exVat': 'Total HT',
  'ui.summary.vat': 'TVA',
  'ui.summary.total': 'Total',
  'ui.more': 'Plus',
  'ui.filter': 'Filtre',
  'ui.filterReset': 'Réinitialiser le filtre',
  'ui.filterChoices': 'Options de filtre',
  'ui.period': 'Période',
  'ui.from': 'Du',
  'ui.to': 'Au',
  'ui.fromMonth': 'Du mois',
  'ui.toMonth': 'Au mois',
  'ui.fromDate': 'Date de début',
  'ui.toDate': 'Date de fin',
  'ui.today': 'Aujourd\'hui',
  'ui.wholeYearTitle': 'Toute l\'année {year}',
  'ui.quick.wholeYear': 'Toute l\'année',
  'ui.quick.ytd': 'Depuis le début de l\'année',
  'ui.quick.thisTerm': 'Cette période',
  'ui.quick.lastYear': 'Année précédente',
  'ui.term': 'Période {n}',
  'ui.amountSearch': 'Rechercher par montant',
  'ui.amountFrom': 'Montant min.',
  'ui.amountTo': 'Montant max.',
  'list.search': 'Rechercher',
  'list.copy': 'Copier',
  'list.copied': 'Copié : {text}',
  'list.export': 'Exporter',
  'list.download': 'Télécharger',
  'list.downloaded': '{label} téléchargé',
  'list.nothingToExport': 'Aucune ligne à exporter',
  'list.downloading': 'Téléchargement de {label} …',
  'list.upload': 'Importer',
  'list.add': 'Ajouter',
  'list.archiveTitle': 'Déplacer vers l\'archive ?',
  'list.archiveConfirm': 'Déplacer vers l\'archive',
  'list.deleteTitle': 'Supprimer ?',
  'list.delete': 'Supprimer',
  'list.archiveBody': 'Voulez-vous déplacer {name} vers l\'archive ? Le client sera masqué des listes de clients actifs, mais les factures, paiements et l\'historique seront conservés. Cette action ne peut pas être annulée d\'ici.',
  'list.deleteBody': 'Voulez-vous vraiment supprimer {name} ? Cette action est irréversible.',
  'crm.prospect': 'Prospect',
  'crm.active': 'Actif',
  'crm.quoteSent': 'Devis envoyé',
  'crm.pause': 'En pause',
  'badge.paid': 'Réglé',
  'badge.active': 'Actif',
  'badge.sent': 'Envoyé',
  'badge.draft': 'Brouillon',
  'badge.created': 'Non envoyé',
  'badge.overdue': 'En retard',
  'badge.credited': 'Crédité',
  'badge.inactive': 'Inactif',
  'badge.ok': 'Déposé',
  'badge.no': 'Non déposé',
  'badge.soon': 'Échéance proche',
  'status.draft': 'Brouillon',
  'status.created': 'Non envoyé',
  'status.sent': 'Envoyé',
  'status.paid': 'Payé',
  'status.overdue': 'En retard',
  'status.credited': 'Crédité',
  'app.loading': 'Chargement de votre comptabilité…',
  'app.loadingPersonalFinance': 'Chargement de vos finances personnelles…',
  'app.loadingEmployeePortal': 'Chargement de votre portail salarié…',
  'project.cost.field': 'Projet',
  'project.cost.none': 'Aucun projet',
  'project.cost.billable': 'Refacturé au client',
  'project.cost.pickTitle': 'Choisir un projet',
  'project.cost.search': 'Rechercher un projet ou un client',
  'project.cost.searchEmpty': 'Aucun projet ne correspond à la recherche.',
  'project.cost.toProject': 'Vers le projet',
  'app.employeePortalVerifyTitle': 'Confirmez votre adresse e-mail',
  'app.employeePortalVerifyText': 'Nous avons envoyé un lien de confirmation à {{email}}. Il peut mettre quelques minutes à arriver. Vérifiez aussi vos courriers indésirables. Ouvrez le lien pour continuer.',
  'app.employeePortalVerifyResend': 'Renvoyer le lien',
  'app.employeePortalVerifySent': 'Le lien de confirmation a été renvoyé.',
  'app.employeePortalVerifyAlready': 'L\'adresse e-mail est déjà confirmée. Rechargez la page.',
  'app.employeePortalVerifyFailed': 'Impossible d\'envoyer le lien de confirmation.',
  'app.emailVerifyCheck': 'J\'ai confirmé',
  'app.emailVerifyConfirmed': 'L\'adresse e-mail est confirmée.',
  'app.emailVerifyNotConfirmed': 'L\'adresse e-mail n\'est pas encore confirmée. Ouvrez le lien dans l\'e-mail et réessayez.',
  'app.emailVerifyCheckFailed': 'Impossible de vérifier l\'adresse e-mail.',
  'app.emailVerifyInitialFailed': 'Le compte a été créé, mais le lien de confirmation n\'a pas pu être envoyé. Essayez de le renvoyer.',
  'app.placeholder.title': 'Cette page arrive bientôt',
  'app.placeholder.text': 'Nous peaufinons les derniers détails. Revenez bientôt !',
  'app.nobusiness.title': 'Par quoi souhaitez-vous commencer ?',
  'app.nobusiness.text': 'Vous êtes connecté, mais vous n\'avez pas encore d\'entreprise dans Plumme.',
  'app.nobusiness.create': 'Créer une entreprise',
  'app.nobusiness.signOut': 'Se déconnecter',
  'common.signOut': 'Se déconnecter',
  'auth.sub.default': 'Une comptabilité simple pour les petites entreprises',
  'auth.sub.forgot': 'Réinitialisez votre mot de passe',
  'auth.sub.sent': 'Consultez votre messagerie',
  'auth.sub.signup': 'Créez un compte et configurez votre entreprise',
  'auth.language': 'Langue',
  'auth.invite.household': 'Vous avez reçu une invitation aux finances du foyer. Connectez-vous ou créez un compte avec l\'adresse e-mail à laquelle l\'invitation a été envoyée.',
  'auth.invite.business': 'Vous avez reçu une invitation client. Saisissez l\'adresse e-mail à laquelle l\'invitation a été envoyée, et nous ouvrirons l\'invitation après votre connexion.',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'vous@exemple.fr',
  'auth.password': 'Mot de passe',
  'auth.name': 'Nom',
  'auth.namePlaceholder': 'Votre nom',
  'auth.passwordMin': 'Au moins 6 caractères',
  'auth.showPassword': 'Afficher le mot de passe',
  'auth.hidePassword': 'Masquer le mot de passe',
  'auth.remember': 'Se souvenir de moi',
  'auth.forgot': 'Mot de passe oublié ?',
  'auth.signIn': 'Se connecter',
  'auth.signingIn': 'Connexion...',
  'auth.noAccount': 'Pas encore de compte ?',
  'auth.createAccount': 'Créer un compte',
  'auth.creating': 'Création...',
  'auth.backToLogin': 'Retour à la connexion',
  'auth.forgotCopy': 'Saisissez l\'adresse e-mail avec laquelle vous vous connectez, et nous vous enverrons un lien pour créer un nouveau mot de passe.',
  'auth.sendResetLink': 'Envoyer le lien de réinitialisation',
  'auth.sending': 'Envoi...',
  'auth.sentCopy': 'Nous avons envoyé un lien à {email}. Suivez le lien dans l\'e-mail pour créer un nouveau mot de passe.',
  'auth.wrongEmail': 'Mauvaise adresse e-mail ? Réessayez',
  'auth.error.signIn': 'La connexion a échoué.',
  'auth.error.reset': 'Impossible d\'envoyer le lien de réinitialisation.',
  'auth.error.signUp': 'Impossible de créer le compte.',
  'capture.scan': 'Scanner un justificatif',
  'capture.toInbox': 'Vers la boîte de réception',
  'capture.toPurchase': 'Vers Achat payé',
  'capture.analysisFailed': 'Le justificatif a été importé, mais l\'analyse a échoué.',
  'capture.readyInPurchase': 'Le justificatif est prêt dans Achat payé.',
  'capture.uploadingToInbox': 'Importation du justificatif dans la boîte de réception ...',
  'capture.uploadedToInbox': 'Justificatif importé dans la boîte de réception.',
  'capture.uploadFailed': 'Impossible d\'importer le justificatif.',
  'capture.analysisTimedOut': 'Le justificatif a été transmis. L\'analyse prend un peu plus de temps et se poursuit en arrière-plan.',
  'capture.paymentDialogLoadFailed': 'Impossible de charger les options de paiement. Réessayez.',
  'nav.home': 'Accueil',
  'nav.aiBookkeeper': 'AI Comptable',
  'nav.aiAdvisor': 'AI Conseiller',
  'nav.newSale': 'Nouvelle vente',
  'nav.invoices': 'Liste des factures',
  'nav.otherSales': 'Autre vente',
  'nav.customers': 'Clients',
  'nav.products': 'Produits',
  'nav.projects': 'Projets',
  'nav.subscriptions': 'Contrats',
  'nav.newPurchase': 'Nouvel achat',
  'nav.manualEntry': 'Écriture libre',
  'nav.suppliers': 'Fournisseurs',
  'nav.assets': 'Immobilisations',
  'nav.inventory': 'Stock',
  'nav.inbox': 'Boîte de réception',
  'nav.incomeStatement': 'Compte de résultat',
  'nav.trialBalance': 'Balance générale',
  'nav.budget': 'Budget',
  'nav.filings': 'MVA-melding',
  'nav.taxReturn': 'Skattemelding',
  'nav.yearEndClosing': 'Clôture annuelle',
  'nav.annualAccounts': 'Comptes annuels',
  'nav.payroll': 'Paie',
  'nav.mileageLog': 'Journal de bord kilométrique',
  'nav.vouchers': 'Transactions',
  'nav.bank': 'Banque',
  'nav.myPage': 'Mon espace',
  'nav.activityLog': 'Journal d\'activité',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Paramètres',
  'navgroup.sales': 'Ventes',
  'navgroup.purchases': 'Achats',
  'navgroup.reports': 'Rapports',
  'navgroup.filings': 'Déclarations',
  'navgroup.employees': 'Salariés',
  'navgroup.other': 'Autre',
  'navgroup.miscellaneous': 'Divers',
  'navgroup.ai': 'AI',
  'navgroup.settings': 'Paramètres',
  'navhelp.home': 'Votre page d\'accueil – chiffres clés, graphiques et raccourcis pour enregistrer ventes et achats.',
  'navhelp.aiBookkeeper': 'SuperPlumma passe en revue la banque, les justificatifs, la TVA et les échéances, et fait des propositions. Vous vérifiez et approuvez avant toute comptabilisation.',
  'navhelp.aiAdvisor': 'Conseil financier de SuperPlumma – score de santé, recommandations, prévision de trésorerie, risques et optimisation fiscale.',
  'navhelp.newSale': 'Créez une nouvelle facture ou un devis pour un client. La vente est comptabilisée automatiquement.',
  'navhelp.invoices': 'Vue d\'ensemble de toutes les factures et devis – statut, échéance et paiement.',
  'navhelp.customers': 'Votre fichier clients. Ajoutez et modifiez les clients que vous facturez.',
  'navhelp.products': 'Les biens et services que vous vendez, avec prix et taux de TVA – prêts à être utilisés sur les factures.',
  'navhelp.projects': 'Saisissez des heures sur des projets et activités, suivez ce qui a été fait et transformez les heures non facturées en brouillons de facture.',
  'navhelp.subscriptions': 'Abonnements, factures récurrentes et listes de clients avec contrôle des envois automatiques.',
  'navhelp.newPurchase': 'Enregistrez un achat ou une facture fournisseur avec justificatif, fournisseur, montant et compte.',
  'navhelp.manualEntry': 'Comptabilisez manuellement directement sur un compte lorsque vous avez besoin d\'un contrôle total de l\'écriture.',
  'navhelp.suppliers': 'Votre fichier fournisseurs – nom, numéro d\'organisation et numéro de compte pour les paiements.',
  'navhelp.assets': 'Immobilisations et biens durables amortis dans le temps.',
  'navhelp.inventory': 'Inventaire et valeur de votre stock. Documentez le comptage et comptabilisez la variation de stock.',
  'navhelp.inbox': 'Justificatifs reçus mais pas encore comptabilisés. Faites-les glisser sur la bonne écriture.',
  'navhelp.incomeStatement': 'Produits moins charges – vous montre si l\'entreprise est bénéficiaire.',
  'navhelp.trialBalance': 'Solde de tous les comptes – la base de vos rapports comptables.',
  'navhelp.budget': 'Établissez un budget et suivez où vous en êtes par rapport à vos objectifs.',
  'navhelp.filings': 'Vérifiez la base de TVA de chaque période. La déclaration elle-même est déposée auprès de Skatteetaten.',
  'navhelp.taxReturn': 'Brouillon de skattemelding basé sur la comptabilité – vérifiez les chiffres avant de la déposer auprès de Skatteetaten.',
  'navhelp.yearEndClosing': 'Étape par étape à travers tout ce qu\'il faut faire pour clôturer l\'exercice.',
  'navhelp.annualAccounts': 'Résultat, bilan, notes et signature. Les comptes annuels sont déposés au Regnskapsregisteret en dehors de Plumme.',
  'navhelp.payroll': 'Lancez la paie, créez les bulletins de paie et comptabilisez la paie. L\'A-melding est déposée en dehors de Plumme.',
  'navhelp.mileageLog': 'Enregistrez vos trajets professionnels et consultez les kilomètres et déductions de l\'année.',
  'navhelp.vouchers': 'Vue d\'ensemble des transactions comptabilisées et de leurs justificatifs – recherchez et retrouvez-les.',
  'navhelp.bank': 'Importez vos relevés bancaires et rapprochez les comptes bancaires de la comptabilité.',
  'navhelp.myPage': 'Votre profil et vos paramètres d\'utilisateur.',
  'navhelp.activityLog': 'Historique complet de ce qui a été fait dans la comptabilité, et par qui.',
  'navhelp.altinn': 'Raccourci vers les dépôts et le courrier dans Altinn.',
  'navhelp.settings': 'Paramètres de la société, de la comptabilité et de l\'application.',
  'navhelp.fallback': 'Ouvrir {label}.',
  'route.home': 'Accueil',
  'route.newSale': 'Nouvelle vente',
  'route.newSaleliste': 'Liste des factures',
  'route.customers': 'Clients',
  'route.products': 'Produits',
  'route.projects': 'Projets',
  'route.aiBookkeeper': 'AI Comptable',
  'route.aiAdvisor': 'AI Conseiller',
  'route.newPurchase': 'Achat payé',
  'route.manualEntry': 'Écriture libre',
  'route.vouchers': 'Transactions',
  'route.suppliers': 'Fournisseurs',
  'route.assets': 'Immobilisations',
  'route.filings': 'Déclarations',
  'route.inbox': 'Boîte de réception',
  'route.documentation': 'Documentation',
  'route.mileageLog': 'Journal kilométrique',
  'route.bank': 'Banque',
  'route.altinn': 'Altinn',
  'route.settings': 'Paramètres',
  'route.otherSales': 'Autres ventes',
  'route.subscriptions': 'Contrats',
  'route.incomeStatement': 'Compte de résultat',
  'route.trialBalance': 'Balance générale',
  'route.budget': 'Budget',
  'route.payroll': 'Paie',
  'route.taxReturn': 'Skattemelding',
  'route.yearEndClosing': 'Clôture annuelle',
  'route.annualAccounts': 'Comptes annuels',
  'route.myPage': 'Mon espace',
  'route.employeePortal': 'Portail salarié',
  'route.activityLog': 'Journal d\'activité',
  'route.personalFinance': 'Finances personnelles',
  'shell.openMenu': 'Ouvrir le menu',
  'shell.closeMenu': 'Fermer le menu',
  'shell.collapseMenu': 'Réduire le menu',
  'shell.showLabels': 'Afficher les libellés',
  'shell.hideLabels': 'Masquer les libellés',
  'shell.designSystem': 'Système de design ↗',
  'shell.customizeMenu': 'Personnaliser le menu',
  'shell.customizeHelpTitle': 'Personnaliser le menu',
  'shell.customizeHelp': 'Choisissez les pages affichées dans le menu latéral. Masquez celles que vous n\'utilisez pas pour garder un menu clair.',
  'shell.customizeTitle': 'Personnaliser le menu latéral',
  'shell.customizeVisible': '{visible} sur {total} visibles',
  'shell.customizeLead': 'Désactivez les pages que vous n\'utilisez pas et elles disparaîtront du menu latéral. Vous pouvez les réactiver à tout moment.',
  'shell.customizeAllPages': 'Toutes les pages',
  'shell.customizeAiMode': 'Mode IA',
  'shell.customizeAlwaysOn': 'Toujours activé',
  'shell.customizeDone': 'Terminé',
  'shell.camCapture': 'Photographier un justificatif',
  'shell.camHelp': 'Prenez en photo un justificatif avec l\'appareil photo et chargez-le directement dans la boîte de réception ou comme nouvel achat.',
  'shell.moreOptions': 'Plus d\'options',
  'shell.search': 'Rechercher',
  'shell.searchAll': 'Tout rechercher',
  'shell.searchHelp': 'Recherchez dans l\'entreprise active — clients, factures, produits, justificatifs, projets, pages et aide. Touchez pour ouvrir la recherche (raccourci : Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Tout rechercher — factures, clients, justificatifs…',
  'shell.searchEnterHint': 'pour voir tous les résultats',
  'shell.companyHelpTitle': 'Choisir une société ou un employeur',
  'shell.companyHelp': 'Passez des comptabilités que vous tenez aux employeurs chez qui vous travaillez. Tout ce que vous voyez dans l\'application concerne la société sélectionnée.',
  'shell.yearHelpTitle': 'Exercice',
  'shell.yearHelp': 'Choisissez l\'exercice sur lequel vous travaillez. Tous les chiffres et dépôts concernent l\'année sélectionnée.',
  'shell.theme.helpTitle': 'Thème clair / sombre',
  'shell.theme.help': 'Basculez entre un affichage clair et sombre dans toute l\'application. Votre choix est mémorisé.',
  'shell.theme.toLight': 'Passer au thème clair',
  'shell.theme.toDark': 'Passer au thème sombre',
  'shell.theme.light': 'Thème clair',
  'shell.theme.dark': 'Thème sombre',
  'shell.bg.label': 'Couleur de fond',
  'shell.bg.title': 'Couleur de fond de cette page',
  'shell.bg.help': 'Choisissez la couleur de fond pour cette page uniquement. La couleur est enregistrée par page.',
  'shell.bg.menuTitle': 'Couleur de fond · cette page',
  'shell.bg.default': 'Prune',
  'shell.bg.mint': 'Menthe',
  'shell.bg.varm': 'Chaud',
  'shell.bg.sky': 'Bleu',
  'shell.bg.rose': 'Rose',
  'shell.bg.skog': 'Forêt',
  'skin.title': 'Apparence',
  'skin.standard': 'Standard',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Classique',
  'skin.klassiskSub': 'Sobre',
  'shell.client.employers': 'Vos employeurs',
  'shell.client.employer': 'Employeur',
  'shell.client.employee': 'Salarié',
  'shell.client.private': 'Personnel',
  'shell.client.firm': 'Cabinet comptable',
  'shell.client.firmSub': 'Vue clients et rapprochement',
  'rf.firm': 'Cabinet comptable',
  'rf.role.owner': 'Propriétaire',
  'rf.role.admin': 'Administrateur',
  'rf.role.employee': 'Collaborateur',
  'rf.group.firm': 'Comptable',
  'rf.group.team': 'Chat d\'équipe',
  'rf.group.other': 'Autre',
  'rf.nav.clients': 'Vue d\'ensemble des clients',
  'rf.nav.reconciliation': 'Rapprochement',
  'rf.nav.control': 'Contrôle',
  'rf.nav.teamchat': 'Chat d\'équipe',
  'rf.nav.members': 'Collaborateurs',
  'rf.nav.clientList': 'Clients',
  'rf.client.pageBody': 'Reliez le cabinet à ses clients et affectez des collaborateurs aux missions.',
  'rf.client.addTitle': 'Relier un client',
  'rf.client.addBody': 'Le client doit disposer d\'un compte Plumme pour son entreprise. Le cabinet n\'obtient l\'accès qu\'une fois que le client a accepté.',
  'rf.client.billedTo': 'Qui paie',
  'rf.client.billedToClient': 'Le client paie lui-même',
  'rf.client.billedToFirm': 'Le cabinet paie',
  'rf.client.request': 'Envoyer la demande',
  'rf.client.requesting': 'Envoi …',
  'rf.client.requested': 'La demande a été envoyée au client',
  'rf.avst.noClient': 'Choisissez d\'abord un client',
  'rf.avst.allClients': 'Tous les clients',
  'rf.avst.thisClient': 'Ce client',
  'rf.avst.noClientBody': 'Le rapprochement porte sur un client à la fois. Ouvrez un client depuis la vue d\'ensemble des clients et le dossier de rapprochement suivra.',
  'rf.client.requestedMailFailed': 'La demande a été envoyée, mais la notification par e-mail n\'a pas pu être remise. Le client la verra à sa prochaine connexion.',
  'rf.client.requestedNoRecipient': 'La demande a été envoyée, mais l\'entreprise n\'a aucun propriétaire ni administrateur à notifier. Contactez le client vous-même.',
  'rf.client.noneTitle': 'Aucun client pour l\'instant',
  'rf.client.noneBody': 'Reliez le cabinet à un client à l\'aide de son numéro d\'organisation. Le client doit approuver avant que vous n\'obteniez l\'accès.',
  'rf.client.pendingBody': 'Le client doit accepter la demande dans son propre compte Plumme. Personne au cabinet n\'a accès d\'ici là.',
  'rf.client.assignWho': 'Affecter à la mission',
  'rf.client.assignPick': 'Choisir un collaborateur',
  'rf.client.assignRole': 'Rôle dans la mission',
  'rf.client.assign': 'Affecter',
  'rf.client.assigned': 'Le collaborateur a été affecté au client',
  'rf.client.end': 'Mettre fin à la mission',
  'rf.client.ended': 'La mission a pris fin',
  'rf.client.endConfirm': 'Mettre fin à la mission pour {name} ? Les accès accordés par le cabinet à ses collaborateurs sont retirés en même temps.',
  'fe.title': 'Un cabinet comptable demande l\'accès',
  'fe.theFirm': 'Le cabinet',
  'fe.body': 'Si vous acceptez, les collaborateurs que le cabinet affecte à la mission auront accès à votre comptabilité. Vous pouvez mettre fin à la collaboration à tout moment.',
  'fe.billedToFirm': 'Le cabinet paie l\'abonnement',
  'fe.billedToClient': 'Vous payez l\'abonnement vous-même',
  'fe.accept': 'Donner l\'accès',
  'fe.accepting': 'Acceptation …',
  'fe.accepted': '{firm} a désormais accès à la comptabilité.',
  'fe.decline': 'Refuser',
  'fe.declined': 'La demande a été refusée.',
  'fi.title': 'Vous êtes invité en tant que collaborateur',
  'fi.theFirm': 'le cabinet',
  'fi.body': 'L\'invitation vous donne accès au cabinet lui-même. Vous n\'aurez accès à un client précis qu\'une fois que le cabinet vous aura affecté à une mission.',
  'fi.verifyFirst': 'Confirmez d\'abord votre adresse e-mail. Nous avons envoyé un nouveau lien de confirmation.',
  'fi.accept': 'Rejoindre',
  'fi.accepting': 'Connexion au cabinet …',
  'fi.accepted': 'Vous êtes désormais collaborateur chez {firm}.',
  'fi.acceptFailed': 'Impossible d\'accepter l\'invitation.',
});
